import React from "react";
import { ClipboardList, Users, GraduationCap, Library, Menu, Search } from "lucide-react";
import "./HeaderTop.css";

const HeaderTop = () => {
  return (
    <div className="header-top d-flex justify-content-between align-items-center flex-wrap px-3 py-2">
      <div className="d-flex flex-wrap align-items-center gap-3">
               

        <a href="https://docs.google.com/forms/d/e/1FAIpQLSfU5F1aClHEzOmKZmtMw-7ygtw1sZAw6xrH0BdwU2_b884DeA/viewform" 
            target="_blank" 
            rel="noopener noreferrer"
            className="header-link d-flex align-items-center gap-1"            
            >
              <GraduationCap size={16}/> Seguimiento de Egresados</a>

        <a href="https://iestpgildaballivian.microsite-ebooks724.com/v1/login/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="header-link d-flex align-items-center gap-1"
            >
              <Library size={16}/> Biblioteca Digital</a>

        <a href="#" 
            target="_blank" 
            rel="noopener noreferrer"
            className="header-link d-flex align-items-center gap-1"
            >
              <Library size={16}/> Correo Institucional</a>
        
                
        <a href="https://drive.google.com/file/d/1GqmBqHtM5LRhdhKAwEWci4qN81NknpI7/view?usp=drive_link" 
            target="_blank" 
            rel="noopener noreferrer"
            className="header-link d-flex align-items-center gap-1"
            >
              <Library size={24}/> <font color="#f01e75"> ---¡¡¡ RESULTADOS EXAMEN DE ADMISIÓN 2026 !!! ----</font></a>
      </div>
      <div className="d-flex align-items-center gap-2">
        <Search size={18} className="icon-action" />
        <Menu size={20} className="icon-action" />
      </div>
    </div>
  );
};

export default HeaderTop;
